import React from "react";
import { useTranslation } from "react-i18next";
import "./buttonViewStyles.css";
import { useFocusable } from "../../../utils/Helpers";
export var ExitButtonView = function (_a) {
    var onExit = _a.onExit, onClose = _a.onClose, closeLabel = _a.closeLabel, exitLabel = _a.exitLabel;
    var t = useTranslation().t;
    var closeRef = useFocusable({
        group: "exitModal",
        index: 0,
        onKeyDown: onClose,
        onKeyBack: onClose,
    });
    var exitRef = useFocusable({
        group: "exitModal",
        index: 1,
        onKeyDown: onExit,
        onKeyBack: onClose,
    });
    return (React.createElement("div", { className: "btn-container", id: "exit-confirm-modal" },
        React.createElement("button", { tabIndex: 0, ref: closeRef, className: "purple-border-btn" }, closeLabel || t("modal.close")),
        React.createElement("button", { tabIndex: 0, ref: exitRef, className: "purple-border-btn" }, exitLabel || t("modal.exit"))));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/views/buttons/ExitButtonView.tsx
// module id = 49
// module chunks = 1